export default "__VITE_PUBLIC_ASSET__8f95a00e__"